const Modal = (props) => {
    const { isOpen, children } = props;
    return (isOpen)?(<div>{children}</div>):null;
};
export default Modal;
